module.exports = __webpack_public_path__ + "static/media/ursina_badilatti_mood.66b3af1c.jpg";